import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import AppUtil from "utilities/AppUtil";
import httpRequest from "../../services/httpRequest";
import snakecaseKeys from "snakecase-keys";
// Main URL Endpoint
const _urlPrefix = "/job";

export const fetchAllJobs = createAsyncThunk(
    "job/fetchAllJobs",
    async (params) => {
        const result = await httpRequest({
            url: `${_urlPrefix}/list`,
            method: "GET",
            params: AppUtil.toSnakeCaseKey(params)
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);

export const fetchListJob = createAsyncThunk(
  "job/fetchListJob",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/job-client`,
      method: "GET",
      params: AppUtil.toSnakeCaseKey(params)
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);

export const fetchJobPageForCompany = createAsyncThunk(
  "job/fetchJobPageForCompany",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/job-company`,
      method: "GET",
      params: AppUtil.toSnakeCaseKey(params)
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);

export const fetchJobDetail = createAsyncThunk(
  "job/fetchJobDetail",
  async (params) => {
    const { id } = params;
    const result = await httpRequest({
      url: `${_urlPrefix}/detail/${id}`,
      method: "GET"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const reduceCreateJob = createAsyncThunk(
  "job/reduceCreateJob",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}`,
      method: "POST",
      data: snakecaseKeys(params),
      successMessage: "toast.create.200"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
// export const reduceUpdateJob = createAsyncThunk(
//   "job/reduceUpdateJob",
//   async (params) => {
//     const { id } = params;
//     const result = await httpRequest({
//       url: `${_urlPrefix}/update/${id}`,
//       method: "PUT",
//       data: snakecaseKeys(params),
//       successMessage: "toast.update.200"
//     });
//     if (!result) {
//       return;
//     }
//     return result.data;
//   }
// );
export const reduceChangeStatus = createAsyncThunk(
  "job/reduceChangeStatus",
  async (params) => {
    const { id, body } = params;
    const result = await httpRequest({
      url: `${_urlPrefix}/change/status/${id}`,
      method: "PUT",
      data: AppUtil.toSnakeCaseKey(body),
      successMessage: "toast.update.200"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const reduceDeleteJob = createAsyncThunk(
  "job/reduceDeleteJob",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/delete`,
      method: "DELETE",
      data: params,
      successMessage: "toast.remove.200"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const reduceEndJob = createAsyncThunk(
  "job/reduceEndJob",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/end`,
      method: "PUT",
      data: AppUtil.toSnakeCaseKey(params),
      successMessage: "toast.update.200"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const searchWorkerByJobId = createAsyncThunk(
  "job/searchWorkerByJobId",
  async (params) => {
    const result = await httpRequest({
      url: 'worker/search',
      method: "GET",
      params: AppUtil.toSnakeCaseKey(params)
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const getWorkerApplied = createAsyncThunk(
  "job/getWorkerApplied",
  async (params) => {
    const result = await httpRequest({
      url: `worker/workers-applied`,
      method: "GET",
      params: AppUtil.toSnakeCaseKey(params)
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const getWorkerToBooking = createAsyncThunk(
  "job/getWorkerToBooking",
  async (params) => {
    const result = await httpRequest({
      url: `worker/get-workers-to-booking-job`,
      method: "GET",
      params: AppUtil.toSnakeCaseKey(params)
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const getJobCalendar = createAsyncThunk(
  "job/getJobCalendar",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/calendar`,
      method: "GET",
      params: AppUtil.toSnakeCaseKey(params)
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const getJobCalendarByParticipants = createAsyncThunk(
  "job/getJobCalendarByParticipants",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/shift-job-company`,
      method: "GET",
      params: AppUtil.toSnakeCaseKey(params)
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const getEstimateBooking = createAsyncThunk(
  "job/getEstimateBooking",
  async (params) => {
    const result = await httpRequest({
      url: `rate/calculate-price`,
      method: "POST",
      data: AppUtil.toSnakeCaseKey(params)
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const addWorkerToJob = createAsyncThunk(
  "job/addWorkerToJob",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/add-worker-to-job`,
      method: "POST",
      data: snakecaseKeys(params),
      successMessage: "toast.add.200"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const bookWorkerForJob = createAsyncThunk(
  "job/bookWorkerForJob",
  async (params) => {
    const result = await httpRequest({
      url: `booking`,
      method: "POST",
      data: snakecaseKeys(params),
      successMessage: "toast.book.200"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const jobRemoveWorker = createAsyncThunk(
  "job/jobRemoveWorker",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/remove-worker`,
      method: "DELETE",
      params: AppUtil.toSnakeCaseKey(params),
      successMessage: "toast.remove.200"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const getAllCanceledBooking = createAsyncThunk(
  "job/getAllCanceledBooking",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/get-all-canceled-booking`,
      method: "GET",
      params: AppUtil.toSnakeCaseKey(params)
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);

export const fetchAllJob = createAsyncThunk(
  "job/fetchAllJob",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/get-all`,
      method: "GET",
      params: AppUtil.toSnakeCaseKey(params)
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);

export const fetchPagingBookedJobs = createAsyncThunk(
  "job/fetchPagingBookedJobs",
  async (params) => {
      const result = await httpRequest({
          url: `${_urlPrefix}/page`,
          method: "GET",
          params: AppUtil.toSnakeCaseKey(params)
      });
      if (!result) {
          return;
      }
      return result.data;
  }
);

export const updateInformationJob = createAsyncThunk(
  "job/updateInformationJob",
  async (params) => {
    const { id } = params;
    const result = await httpRequest({
      url: `${_urlPrefix}/update-information-job/${id}`,
      method: "PUT",
      data: snakecaseKeys(params),
      successMessage: "toast.update.200"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);

// Availability
export const addNewShiftSetting = createAsyncThunk(
  "job/addNewShiftSetting",
  async (params) => {
    // const { jobId, addJobAvailabilityRequestList } = params;
    const result = await httpRequest({
      url: `${_urlPrefix}/add-setting-job-availability`,
      method: "POST",
      data: snakecaseKeys(params),
      successMessage: "toast.update.200"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);

export const updateShiftSetting = createAsyncThunk(
  "job/updateShiftSetting",
  async (params) => {
    const { isNotShowNotification, ...dataRequest } = params;
    const requestParams = {
      url: `${_urlPrefix}/update-time-shift`,
      method: "PUT",
      data: snakecaseKeys(dataRequest),
    }
    if (!isNotShowNotification) {
      requestParams.successMessage = "toast.update.200";
    }


    const result = await httpRequest(requestParams);
    if (!result) {
      return;
    }
    return result.data;
  }
);

export const updateShiftSegment = createAsyncThunk(
  "job/updateShiftSegment",
  async (params) => {
    const { isNotShowNotification, ...dataRequest } = params;
    const requestParams = {
      url: `${_urlPrefix}/update-segment-shift`,
      method: "PUT",
      data: snakecaseKeys(dataRequest),
    }
    if (!isNotShowNotification) {
      requestParams.successMessage = "toast.update.200";
    }
    const result = await httpRequest(requestParams);
    if (!result) {
      return;
    }
    return result.data;
  }
);

export const addOrDeleteShiftSetting = createAsyncThunk(
  "job/addOrDeleteShiftSetting",
  async (params) => {
    const { isNotShowNotification, ...dataRequest } = params;
    const requestParams = {
      url: `${_urlPrefix}/add-delete-availability`,
      method: "PUT",
      data: snakecaseKeys(dataRequest),
    }
    if (!isNotShowNotification) {
      requestParams.successMessage = "toast.update.200";
    }
    const result = await httpRequest(requestParams);
    if (!result) {
      return;
    }
    return result.data;
  }
);

export const deleteShiftSetting = createAsyncThunk(
  "job/deleteShiftSetting",
  async (params) => {
    const { isNotShowNotification, ...dataRequest } = params;
    const requestParams = {
      url: `${_urlPrefix}/delete-setting-job-availability`,
      method: "DELETE",
      data: snakecaseKeys(dataRequest),
    }
    if (!isNotShowNotification) {
      requestParams.successMessage = "toast.update.200";
    }
    const result = await httpRequest(requestParams);
    if (!result) {
      return;
    }
    return result.data;
  }
);

export const fetchTaskPage = createAsyncThunk(
  "job/fetchTaskPage",
  async (params) => {
    const result = await httpRequest({
      url: `/tasks/page`,
      method: "GET",
      params: AppUtil.toSnakeCaseKey(params),
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);

export const createTask = createAsyncThunk(
  "job/createTask",
  async (params) => {
    const { isNotShowNotification, ...dataRequest } = params;
    const requestParams = {
      url: `/tasks/create`,
      method: "POST",
      data: snakecaseKeys(dataRequest),
    };
    if (!isNotShowNotification) {
      requestParams.successMessage = "toast.create.200";
    }
    const result = await httpRequest(requestParams);
    if (!result) {
      return;
    }
    return result.data;
  }
);

export const updateTask = createAsyncThunk(
  "job/updateTask",
  async (params) => {
    const { isNotShowNotification, id, tasksName } = params;
    const requestParams = {
      url: `/tasks/update/${id}`,
      method: "PUT",
      data: snakecaseKeys({ tasksName }),
    };
    if (!isNotShowNotification) {
      requestParams.successMessage = "toast.update.200";
    }
    const result = await httpRequest(requestParams);
    if (!result) {
      return;
    }
    return result.data;
  }
);

export const deleteTask = createAsyncThunk(
  "job/deleteTask",
  async (params) => {
    const { isNotShowNotification, id } = params;
    const requestParams = {
      url: `/tasks/delete/${id}`,
      method: "DELETE",
    };
    if (!isNotShowNotification) {
      requestParams.successMessage = "toast.remove.200";
    }
    const result = await httpRequest(requestParams);
    if (!result) {
      return;
    }
    return result.data;
  }
);

const initialState = {
  list: [],
  participantJobList: [],
  detail: {},
  bookingWillCancelList: [],
  listAll: []
};

const job = createSlice({
  name: "job",
  initialState: initialState,
  reducers: {
  },
  extraReducers: {
    [fetchJobDetail.pending]: (state) => {
      const { detail } = state;
      detail.specialty = [];
      detail.support = [];
    },
    [fetchJobDetail.fulfilled]: (state, action) => {
      if (action.payload) {
        Object.keys(action.payload)
        .forEach(key => {
          state.detail[key] = action.payload[key] || action.payload[key] === false ? action.payload[key] : "";
        });
      }
    },
    [getAllCanceledBooking.pending]: (state) => {
      state.bookingWillCancelList = [];
    },
    [getAllCanceledBooking.fulfilled]: (state, { payload }) => {
      if (payload) {
        state.bookingWillCancelList = payload;
      }
    },
    [fetchListJob.fulfilled]: (state, { payload }) => {
      if (payload) {
        state.list = payload.content;
      }
    },
    [fetchPagingBookedJobs.fulfilled]: (state, { payload }) => {
      if (payload) {
        state.participantJobList = payload.content;
      }
    },
    [fetchJobPageForCompany.fulfilled]: (state, { payload }) => {
      if (payload) {
        state.list = payload.content;
      }
    },
    [fetchAllJob.fulfilled]: (state, { payload }) => {
      if (payload) {
        state.listAll = payload;
      }
    }
  }
});

const { reducer } = job;
export default reducer;

export const getJobDetail = createSelector(
  (state) => state.job.detail,
  (user) => user
);
export const getJobList = createSelector(
  state => state.job.list,
  list => list
);

export const getAllJob = createSelector(
  state => state.job.listAll,
  listAll => listAll
);
export const getParticipantJobList = createSelector(
  state => state.job.participantJobList,
  participantJobList => participantJobList
);
